export default __webpack_public_path__ + "static/media/GA_Mix-3.625c9d0f.wav";